<div [ngClass]="this.menuService.menuOptions['calculation'] ? 'active' : ''" class="calculation-menu" id="calculations">
  <div>
    <h1>Calculation</h1>
    <ul>
      <h4>Impact Assessment</h4>
      <app-menu-option
        [action]="this.openImpactCalculationPopup.bind(this)"
        [label]="'Area of Impact'">
      </app-menu-option>

      <h4>Area</h4>
      <app-menu-option
        [action]="this.openAreaCoveragePopup.bind(this)"
        [label]="'Area Coverage'">
      </app-menu-option>

<!--      <app-menu-option
        [action]="this.openAreaCumulativeCoveragePopup.bind(this)"
        [label]="'Area Cumulative Coverage'">
      </app-menu-option>
      <app-menu-option
        [action]="this.openAreaPerformancePopup.bind(this)"
        [label]="'Area Performance'">
      </app-menu-option>

      <h4>Procedure</h4>
      <app-menu-option
        [action]="this.openPerformanceAnalysisPopup.bind(this)"
        [label]="'Procedure Performance Analysis'">
      </app-menu-option>
      <app-menu-option
        [action]="this.openVerticalProfilePopup.bind(this)"
        [label]="'Procedure Vertical Profile'">
      </app-menu-option>
      <app-menu-option
        [action]="this.calculationValidationService.openRoutePerformanceReportPopupInitialization.bind(calculationValidationService)"
        [label]="'Procedure Performance Report'">
      </app-menu-option>-->

      <!--<h4>Others</h4>
      <app-menu-option [label]="this.genericController.showMesssageModal('Build Calculation Database')">Build Calculation Databas</app-menu-option>
      <app-menu-option [label]="this.genericController.showMesssageModal('Delete Calculation Database')">Delete Calculation Databas</app-menu-option>
      <app-menu-option [label]="this.genericController.showMesssageModal('Manage Saved Results')">Manage Saved Result</app-menu-option>-->
    </ul>
  </div>
</div>
